/* QUIZ.
   El cambio de pantalla es un fundido en dos tiempos, no un reemplazo seco.
   MEDIDO cuadro por cuadro sobre su video a 58fps (lo que decia antes este
   comentario estaba mal: salia de un video a 30fps donde no se distinguia):
     sale   titulo y opciones juntos, 33 cuadros = 570ms
     entra  el titulo solo, y recien 400ms despues arrancan las opciones
   El contenido se reemplaza en el medio, cuando ya no se ve nada. El alto de la
   caja se sigue interpolando, igual que en su mega menu. */
(function(){
  var cfg = window.RZ_QUIZ || {};
  var raiz = document.getElementById('rz-quiz');
  if(!raiz || !cfg.packs || !cfg.packs.length) return;

  var caja   = raiz.querySelector('[data-quiz-caja]');
  var pant   = raiz.querySelector('[data-quiz-pant]');
  var inner  = raiz.querySelector('.rz-quiz__inner');
  var barra  = raiz.querySelector('[data-quiz-progreso]');
  var volver = raiz.querySelector('[data-quiz-volver]');

  var paso = 0;
  var resp = { vez:null, meses:null, extras:[] };

  function plata(c){
    var n = Math.round(c/100);
    return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function esc(t){ return String(t).replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function foto(f, ancho){ return cfg.cdn + f + '&width=' + (ancho || 500); }

  /* ---------- las pantallas ---------- */
  var PASOS = [
    { clave:'vez', titulo:'¿Es tu primera vez con Raizal?', multi:false,
      ops:[ {v:'primera', t:'Primera vez'}, {v:'repite', t:'Ya lo usé'} ] },

    { clave:'meses', titulo:'¿Cuánto querés sostenerlo?', bajada:'Cada frasco de 200 ml rinde un mes de uso diario.',
      multi:false, fichas:true, ops:[
        /* En ficha el rotulo va corto, como los de ellos ("Breakfast", "Lunch"):
           una frase entera no entra en 171px y ademas rompe la lectura de un
           golpe que es lo que hace que la grilla funcione. */
        {v:1, t:'Probarlo un mes',            c:'1 mes'},
        {v:3, t:'El ciclo completo de 3 meses', c:'3 meses'},
        {v:6, t:'Sostenerlo 6 meses',         c:'6 meses'} ] },

    { clave:'extras', titulo:'¿Qué le sumás?', bajada:'Podés elegir más de uno.', multi:true, fichas:true, ops:[] },

    { clave:'mail' },
    { clave:'listo' }
  ];

  /* Los extras salen del catalogo, no de una lista escrita a mano. */
  PASOS[2].ops = (cfg.extras||[]).map(function(e){
    return {v:e.clave, t:e.titulo, c:(e.titulo === 'Masajeador capilar' ? 'Masajeador' : e.titulo)};
  });
  PASOS[2].ops.push({ v:'nada', t:'Solo el shampoo', solo:true });

  function packElegido(){
    var m = resp.meses || 3;
    for(var i=0;i<cfg.packs.length;i++) if(cfg.packs[i].meses === m) return cfg.packs[i];
    return cfg.packs[0];
  }
  function extrasElegidos(){
    return (cfg.extras||[]).filter(function(e){ return resp.extras.indexOf(e.clave) > -1; });
  }

  /* El mismo spinner que el CTA de la ficha de producto: doce rayitas y un paso
     por rayita, no un giro continuo. */
  var RUEDA = (function(){
    var r = '';
    for(var i=0;i<12;i++){
      r += '<rect x="11.1" y="1.6" width="1.8" height="5.4" rx=".9" opacity="' +
           ((i+1)/12).toFixed(2) + '" transform="rotate(' + (i*30) + ' 12 12)"/>';
    }
    return '<svg viewBox="0 0 24 24" fill="currentColor">' + r + '</svg>';
  })();

  /* ---------- los dibujos de las fichas ----------
     Line art, un solo trazo, mismo peso que los iconos del resto del sitio.
     Dos clases mandan la animacion del click:
       .cuerpo  la parte fija (el frasco, la cupula, la linea del cuero)
       .ac      los trazos que se retraen y vuelven a salir
     Es el mismo gesto que hace el de ellos: MEDIDO en el video de Mark, los rayos
     del sol se meten adentro del circulo en 30 cuadros (520ms) y vuelven a salir
     en 36 (620ms). Total 1,14s. */
  function svg(cuerpo, anim){
    return '<svg class="rz-quiz__dib" data-anim="' + anim + '" viewBox="0 0 48 56" fill="none" ' +
           'stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" ' +
           'aria-hidden="true">' + cuerpo + '</svg>';
  }

  function almanaque(puntos){
    var d = '<rect class="cuerpo" x="8" y="13" width="32" height="31" rx="4"/>' +
            '<path class="cuerpo" d="M8 23h32"/>' +
            '<path class="cuerpo" d="M17 9v8"/><path class="cuerpo" d="M31 9v8"/>';
    for(var i=0;i<puntos.length;i++){
      d += '<circle class="ac" style="--i:' + i + '" cx="' + puntos[i][0] +
           '" cy="' + puntos[i][1] + '" r="2.4"/>';
    }
    return svg(d, 'dias');
  }
  function frasco(x){
    return '<rect class="cuerpo" x="' + x + '" y="17" width="18" height="33" rx="5"/>' +
           '<path class="cuerpo" d="M' + (x+6) + ' 17v-5h6v5"/>' +
           '<rect class="cuerpo" x="' + (x+5) + '" y="7" width="8" height="5" rx="2"/>';
  }
  var FRASCO = frasco(15);
  var FRASCO_IZQ = frasco(9);

  /* El masajeador de la primera version quedaba amontonado: cinco puas naciendo
     de la curva misma, con las bolitas pegadas una a la otra, se leia como una
     mancha. Ahora la cupula termina en una barra y las puas cuelgan DE la barra,
     que es como es el objeto de verdad y ademas deja el dibujo mas limpio.
     Cada pua y su bolita van juntas en un <g>, asi el grupo entero puede girar
     alrededor del centro de la cupula: ese giro es la animacion —el masajeador
     se abre y se cierra— en vez de un trazo que se borra. */
  function masajeador(){
    var d = '<path class="cuerpo" d="M14 26a10 10 0 0 1 20 0"/>' +
            '<path class="cuerpo" d="M12.5 27.5h23"/>';
    /* El signo del giro: en coordenadas de pantalla el angulo positivo es horario,
       y para un punto que cuelga POR DEBAJO del pivote eso lo corre hacia la
       izquierda. O sea que las puas de la izquierda llevan angulo positivo si se
       tienen que abrir. La primera vez lo puse al reves y el masajeador se
       cerraba en lugar de abrirse. */
    var puas = [[15,11,2],[19.5,5.5,1],[24,0,0],[28.5,-5.5,1],[33,-11,2]];
    for(var i=0;i<puas.length;i++){
      var x=puas[i][0], giro=puas[i][1], orden=puas[i][2];
      d += '<g class="ac" style="--r:' + giro + ';--i:' + orden + '">' +
             '<path d="M' + x + ' 29V42"/>' +
             '<circle cx="' + x + '" cy="44" r="1.5"/>' +
           '</g>';
    }
    return svg(d, 'puas');
  }

  var DIBUJOS = {
    '1': almanaque([[24,34]]),
    '3': almanaque([[16,34],[24,34],[32,34]]),
    '6': almanaque([[16,30],[24,30],[32,30],[16,38],[24,38],[32,38]]),
    acond: svg(FRASCO +
      '<path class="ac" style="--i:0" d="M19 34q5-3.5 10 0"/>' +
      '<path class="ac" style="--i:1" d="M19 41q5-3.5 10 0"/>', 'ondas'),
    masaj: masajeador(),
    /* Las burbujas estaban repartidas a los dos lados del tapon y quedaban
       sueltas, sin contar nada. Ahora suben en diagonal desde el hombro derecho
       del frasco: se lee de donde salen y para donde van, que es justo lo que la
       animacion despues hace. El frasco se corre a la izquierda para compensar. */
    nada: svg(FRASCO_IZQ +
      '<circle class="ac" style="--i:0" cx="34" cy="24" r="2.8"/>' +
      '<circle class="ac" style="--i:1" cx="39" cy="16" r="2"/>' +
      '<circle class="ac" style="--i:2" cx="35" cy="9" r="1.4"/>', 'burbujas')
  };

  /* ---------- dibujar ---------- */
  var TILDE = '<span class="rz-quiz__tilde" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
      'stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg></span>';

  function opciones(p){
    var val = resp[p.clave];
    var fichas = !!p.fichas;
    return '<div class="rz-quiz__ops' + (p.multi ? ' es-multi' : '') +
           (fichas ? ' rz-quiz__ops--fichas' : '') + '">' +
      p.ops.map(function(o, i){
        var on = p.multi ? (val.indexOf(o.v) > -1) : (val === o.v);
        /* La entrada escalonada es de ellos: cada ficha declara su propio retraso
           y entran una atras de otra. En su HTML figura como --entrance: calc(.1s * n). */
        var dib = fichas ? (DIBUJOS[String(o.v)] || '') : '';
        return '<button class="rz-quiz__op' + (fichas ? ' rz-quiz__op--ficha' : '') +
               (on ? ' esta-on' : '') + '" type="button" ' +
               (fichas ? 'style="--rz-entrada:' + (i * 90) + 'ms" ' : '') +
               'data-op="' + esc(o.v) + '"' + (o.solo ? ' data-solo="1"' : '') +
               ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
                 dib +
                 '<span class="rz-quiz__rot">' + esc(fichas ? (o.c || o.t) : o.t) + '</span>' +
                 TILDE +
               '</button>';
      }).join('') + '</div>';
  }

  function listo(p){
    if(p.clave === 'vez' || p.clave === 'meses') return resp[p.clave] !== null;
    if(p.clave === 'extras') return resp.extras.length > 0;
    return true;
  }

  function pantallaPregunta(p){
    return '<h2 class="rz-quiz__h">' + esc(p.titulo) + '</h2>' +
           (p.bajada ? '<p class="rz-quiz__sub">' + esc(p.bajada) + '</p>' : '') +
           opciones(p) +
           '<button class="rz-quiz__seguir" type="button" data-quiz-seguir' +
             (listo(p) ? '' : ' disabled') + '>Continuar</button>';
  }

  /* La pantalla del mail es una tarjeta de dos columnas, calcada de la de ellos:
     arriba una tira verde con los beneficios, abajo la foto a la izquierda y el
     formulario a la derecha. Los numeros salen de su CSS, estan en el CSS nuestro.
     La foto es la del pack que la persona eligio recien, no una generica. */
  function ventaja(t){
    return '<span class="rz-quiz__ventaja">' +
      '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10"/>' +
      '<path d="m5.6 10.3 2.9 2.9 5.9-6" fill="none" stroke="#FFFFFF" stroke-width="1.9" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(t) + '</span>';
  }
  /* La foto de esta pantalla la eligio Mark: es fija, no la del pack elegido. */
  var FOTO_MAIL = 'https://cdn.shopify.com/s/files/1/0758/8868/9401/files/' +
                  'hf_20260909_165212_bd1b6e37-0ed6-4a92-a43d-10f1386b509f.png?v=1788973096';
  function pantallaMail(){
    return '<div class="rz-quiz__tarjeta">' +
      '<div class="rz-quiz__tira">' +
        ventaja('Tu resultado guardado') +
        ventaja('Cómo usarlo, semana a semana') +
        ventaja('Avisos de reposición') +
        ventaja('Ofertas que no salen en la web') +
      '</div>' +
      '<div class="rz-quiz__tviz">' +
        '<img src="' + FOTO_MAIL + '&width=900" alt="Raizal" ' +
        'width="438" height="376" loading="lazy" decoding="async">' +
      '</div>' +
      '<div class="rz-quiz__ttxt">' +
        '<h2 class="rz-quiz__h">Ya casi.</h2>' +
        '<p class="rz-quiz__sub">Antes de mostrarte el tratamiento que te toca, dejanos el mail: ' +
        'te mandamos el resultado y cómo sacarle el máximo semana a semana.</p>' +
        '<div class="rz-quiz__mail">' +
          '<input type="email" id="rz-quiz-mail" placeholder="tuemail@gmail.com" autocomplete="email" inputmode="email">' +
          '<p class="rz-quiz__error" data-quiz-error hidden>Escribí un mail válido.</p>' +
        '</div>' +
        '<button class="rz-quiz__seguir" type="button" data-quiz-mail>Mandámelo</button>' +
        '<button class="rz-quiz__saltar" type="button" data-quiz-saltar>No, gracias. Mostrame el resultado.</button>' +
        '<p class="rz-quiz__legal">Es opcional y te podés dar de baja cuando quieras.</p>' +
      '</div>' +
    '</div>';
  }

  function pantallaBuscando(){
    return '<div class="rz-quiz__buscando">' +
      '<span class="rz-quiz__rueda" aria-hidden="true"></span>' +
      '<p>Armando tu tratamiento…</p></div>';
  }

  /* La pantalla del resultado, con la forma de la de ellos: una tarjeta por
     producto, cada una con nombre, bajada, beneficios, precio, foto, boton y un
     link redondo arriba a la derecha que lleva a la ficha. Numeros leidos de su
     CSS: tarjeta radio 8 y padding 24 sobre un fondo arena rgb(245,242,236) —que
     es casi exactamente el arena de la casa—, nombre 24px/500, el link redondo
     40x40, y el "rehacer" abajo a la izquierda en su azul de link rgb(3,116,165).

     OJO CON LOS BENEFICIOS: los del shampoo salen del mecanismo documentado en la
     KB. Los del acondicionador y el masajeador son de USO, no promesas de
     resultado, justamente porque no tengo copy aprobado para esos dos. Falta que
     Mark los escriba. */
  var FICHAS = {
    pack:  { url:'/products/raizal-shampoo',
             bajada:'Shampoo Activador de Raíces',
             puntos:['Bloquea la DHT en el folículo',
                     'Activa la microcirculación del cuero cabelludo',
                     'Dos minutos en la ducha, todos los días'] },
    acond: { url:'/products/raizal-acondicionador-activador-de-raices',
             bajada:'Sella la fibra después del shampoo',
             puntos:['Va después de cada lavado', 'Se suma al mismo ritual'] },
    masaj: { url:'/products/masajeador-capilar-de-regalo',
             bajada:'Activa la microcirculación',
             puntos:['Se usa mientras aplicás el shampoo', 'Ayuda a que llegue a la raíz'] }
  };
  var FLECHA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg>';

  function puntos(lista){
    return '<ul class="rz-quiz__puntos">' + lista.map(function(t){
      return '<li><svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10"/>' +
        '<path d="m5.6 10.3 2.9 2.9 5.9-6" fill="none" stroke="#FFFFFF" stroke-width="1.9" ' +
        'stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(t) + '</li>';
    }).join('') + '</ul>';
  }

  function ficha(o){
    /* El id lo usan las pastillas de celu para saltar a la tarjeta. */
    return '<article class="rz-quiz__ficha" id="rz-ficha-' + o.idx + '">' +
      '<div class="rz-quiz__ficha-alto">' +
        '<h3 class="rz-quiz__ficha-n">' + esc(o.nombre) + '</h3>' +
        '<a class="rz-quiz__ficha-ir" href="' + o.url + '" aria-label="Ver la ficha de ' +
          esc(o.nombre) + '">' + FLECHA + '</a>' +
      '</div>' +
      '<p class="rz-quiz__ficha-b">' + esc(o.bajada) + '</p>' +
      puntos(o.puntos) +
      '<p class="rz-quiz__ficha-p">' + o.precio + '</p>' +
      '<div class="rz-quiz__ficha-viz"><img src="' + foto(o.img, 500) + '" alt="" ' +
        'loading="lazy" decoding="async"></div>' +
      /* Cada tarjeta agrega SU producto, como en el de ellos. El boton lleva
         encima los datos que necesita la barra de abajo, asi no hay que volver a
         buscarlos despues. */
      '<button class="rz-quiz__add" type="button" data-quiz-add' +
        ' data-id="' + o.id + '" data-precio="' + o.precioNum + '"' +
        ' data-nombre="' + esc(o.nombre) + '" data-bajada="' + esc(o.bajada) + '"' +
        ' data-img="' + foto(o.img, 200) + '">' +
        '<span class="rz-quiz__add-txt">Agregar al carrito</span>' +
        '<span class="rz-quiz__add-spin" aria-hidden="true">' + RUEDA + '</span>' +
      '</button>' +
      '<a class="rz-quiz__ficha-ver" href="' + o.url + '">Ver el producto</a>' +
    '</article>';
  }

  function pantallaResultado(){
    var pk = packElegido(), ex = extrasElegidos();
    var total = pk.precio + ex.reduce(function(a,e){ return a + e.precio; }, 0);
    var dias = pk.meses * 30;
    var pordia = Math.round(pk.precio / dias / 100) * 100;
    var linea = (resp.vez === 'primera')
      ? 'Para arrancar, esto es lo que te conviene.'
      : 'Para sostener lo que ya lograste, esto es lo que te conviene.';

    var lista = [ficha({
      idx: 0,
      nombre: pk.titulo, url: FICHAS.pack.url + '?variant=' + pk.id,
      bajada: FICHAS.pack.bajada, puntos: FICHAS.pack.puntos, img: pk.img,
      id: pk.id, precioNum: pk.precio,
      /* Barra y no punto medio: es como lo separa Huel ("From £39 / 12 bottles")
         y Mark ya lo pidio para las tarjetas de la grilla. */
      precio: plata(pk.precio) + ' / ' + plata(pordia) + ' por día'
    })];
    lista = lista.concat(ex.map(function(e, i){
      var f = FICHAS[e.clave] || {url:'/', bajada:e.bajada || '', puntos:[]};
      return ficha({ idx:i+1, nombre:e.titulo, url:f.url, bajada:f.bajada, puntos:f.puntos,
                     img:e.img, id:e.id, precioNum:e.precio, precio:plata(e.precio) });
    }));
    /* Los nombres, para las pastillas de celu. */
    var nombres = [pk.titulo].concat(ex.map(function(e){ return e.titulo; }));

    var cuantos = lista.length;
    /* Todo el bloque va adentro de un envoltorio que mide lo mismo que las
       tarjetas. Si no, con una sola tarjeta el titulo quedaba flotando lejos, a
       la izquierda del todo, y las tarjetas centradas en el medio. */
    return '<div class="rz-quiz__resbox"><div class="rz-quiz__res" style="--rz-n:' + cuantos + '">' +
      '<h2 class="rz-quiz__res-h">' +
        (cuantos === 1 ? 'Tenés 1 producto recomendado' : 'Tenés ' + cuantos + ' productos recomendados') +
      '</h2>' +
      '<p class="rz-quiz__res-s">' + linea + '</p>' +
      /* El boton unico de "agregar todo" y la linea del total salieron: ahora
         cada tarjeta agrega lo suyo y el total vive en la barra de abajo. */
      /* Fila de pastillas con los nombres, SOLO en celu: ahi las tarjetas van
         apiladas y sin esto hay que scrollear a ciegas para ver la tercera.
         Es lo que hace la de ellos. Se esconde sola si hay un solo producto. */
      (nombres.length > 1
        ? '<nav class="rz-quiz__chips" aria-label="Ir a un producto">' +
            nombres.map(function(n, i){
              return '<button type="button" data-quiz-ir="' + i + '">' + esc(n) + '</button>';
            }).join('') +
          '</nav>'
        : '') +
      '<div class="rz-quiz__fichas">' + lista.join('') + '</div>' +
      '<p class="rz-quiz__rehacer"><button type="button" data-quiz-rehacer>Rehacer el quiz</button></p>' +
    '</div></div>';
  }

  /* ---------- refrescar SIN volver a dibujar ----------
     ESTE ERA EL BUG de las animaciones. Antes, al elegir una opcion, volvia a
     escribir el HTML entero de la pantalla: el navegador tiraba los elementos
     viejos y creaba unos nuevos YA en su estado final, asi que ninguna
     transicion llegaba a correr. Por eso el tilde aparecia de golpe y el boton
     cambiaba de gris a negro de un salto, por mas que el CSS tuviera sus 200ms.
     Ahora se tocan las clases de los elementos que ya estan en pantalla, que es
     lo unico que deja correr una transicion. */
  function refrescar(p){
    /* Por si el usuario elige antes de que termine la entrada: el boton tiene que
       encenderse ya, no 400ms despues. */
    if(limpiar){ clearTimeout(limpiar); limpiar = null; }
    retrasos(null);
    var val = resp[p.clave];
    var ops = pant.querySelectorAll('[data-op]');
    for(var i=0;i<ops.length;i++){
      var o = ops[i], raw = o.getAttribute('data-op');
      var v = (p.clave === 'meses') ? parseInt(raw, 10) : raw;
      var on = p.multi ? (val.indexOf(v) > -1) : (val === v);
      o.classList.toggle('esta-on', on);
      o.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var seguir = pant.querySelector('[data-quiz-seguir]');
    if(seguir){
      var apagado = !listo(p);
      /* Solo cuando CAMBIA de estado le pongo la clase del encendido lento. Si se
         la dejara puesta, el hover del boton tambien saldria a 480 y el hover de
         toda la pagina es 275. */
      if(seguir.disabled !== apagado){
        seguir.classList.add('se-prende');
        clearTimeout(seguir._t);
        seguir._t = setTimeout(function(){ seguir.classList.remove('se-prende'); }, 380);
      }
      seguir.disabled = apagado;
    }
  }

  /* ---------- la barra de abajo con lo que se fue agregando ----------
     Copia el comportamiento de la de ellos: muestra la foto del PRIMER producto
     que agregaste con una chapita con el total de unidades, su nombre, la suma
     de todo y el boton Continuar, que lleva a la PAGINA del carrito y no al
     cajon. La barra se arma una sola vez y despues solo se actualiza. */
  var sumados = [];      /* lo que se fue agregando, en orden */
  /* OJO CON EL NOMBRE: `barra` ya estaba tomado arriba por la barra de progreso.
     Al declararla de nuevo aca la pisaba con null y `progreso()` reventaba en
     `barra.style`, y el quiz no llegaba a dibujar la primera pantalla. */
  var cinta = null;

  /* Las fotas y los nombres lindos, indexados por variante. Salen del catalogo
     que ya viene en la pagina, asi que sirven aunque `sumados` este vacio —por
     ejemplo si recargaste—. Sin esto la cinta se caia a la imagen que tiene
     Shopify cargada en el producto, que es una placa con texto y no la foto. */
  var PORVARIANTE = (function(){
    var m = {}, i;
    for(i=0;i<(cfg.packs||[]).length;i++){
      m[String(cfg.packs[i].id)] = { img: foto(cfg.packs[i].img, 200),
                                     nombre: cfg.packs[i].titulo,
                                     bajada: FICHAS.pack.bajada };
    }
    for(i=0;i<(cfg.extras||[]).length;i++){
      var f = FICHAS[cfg.extras[i].clave] || {};
      m[String(cfg.extras[i].id)] = { img: foto(cfg.extras[i].img, 200),
                                      nombre: cfg.extras[i].titulo,
                                      bajada: f.bajada || cfg.extras[i].bajada || '' };
    }
    return m;
  })();

  function armarBarra(){
    if(cinta) return cinta;
    var barra = document.createElement('div');
    barra.className = 'rz-quiz__cinta';
    barra.setAttribute('aria-hidden', 'true');
    barra.innerHTML =
      '<span class="rz-quiz__cinta-viz"><span class="rz-quiz__cinta-n">0</span></span>' +
      '<span class="rz-quiz__cinta-txt"><b></b><i></i></span>' +
      '<span class="rz-quiz__cinta-p"></span>' +
      '<a class="rz-b rz-quiz__cinta-cta" href="/cart">Continuar</a>';
    raiz.appendChild(barra);
    cinta = barra;
    return cinta;
  }

  /* Guardamos lo que se agrego DESDE EL QUIZ solo para tener el nombre lindo y la
     foto; la cuenta y el total salen siempre del carrito de verdad. Antes los
     llevaba yo y pasaba esto: sacabas los productos del carrito y la cinta seguia
     mostrandolos, porque mi cuenta no se enteraba. */
  function recordar(dato){
    for(var i=0;i<sumados.length;i++) if(String(sumados[i].id) === String(dato.id)) return;
    sumados.push(dato);
  }

  function esconderCinta(){
    if(!cinta) return;
    cinta.classList.remove('is-on');
    cinta.setAttribute('aria-hidden', 'true');
  }

  /* Un producto que ya esta en el carrito no se puede volver a agregar: el boton
     queda gris y apagado, como el de ellos. La fuente de verdad vuelve a ser el
     carrito y no una marca mia, asi que si lo sacan de ahi el boton se vuelve a
     encender solo en el siguiente refresco. */
  function sincronizarBotones(c){
    var enCarrito = {}, i;
    if(c && c.items) for(i=0;i<c.items.length;i++) enCarrito[String(c.items[i].variant_id)] = true;
    var bs = pant.querySelectorAll('[data-quiz-add]');
    for(i=0;i<bs.length;i++){
      var ya = !!enCarrito[String(bs[i].getAttribute('data-id'))];
      bs[i].disabled = ya;
      bs[i].classList.toggle('ya-esta', ya);
    }
  }

  function pintarCinta(c){
    sincronizarBotones(c);
    if(!c || !c.item_count){ esconderCinta(); return; }
    var b = armarBarra(), i, j;

    /* Los productos del carrito, ordenados como los fuiste agregando desde el
       quiz; los que no reconozco van al final. */
    var enOrden = [];
    for(i=0;i<sumados.length;i++){
      for(j=0;j<c.items.length;j++){
        if(String(c.items[j].variant_id) === String(sumados[i].id)){ enOrden.push(c.items[j]); break; }
      }
    }
    for(j=0;j<c.items.length;j++){
      var esta = false;
      for(i=0;i<enOrden.length;i++) if(enOrden[i].variant_id === c.items[j].variant_id) esta = true;
      if(!esta) enOrden.push(c.items[j]);
    }

    function datos(it){
      var d = PORVARIANTE[String(it.variant_id)];
      if(d) return d;
      return { img: it.image || '',
               nombre: String(it.product_title || '').replace('RAIZAL™ - ', '').replace('Raizal — ', ''),
               bajada: (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '' };
    }

    /* Una miniatura por producto, hasta tres, montadas una sobre otra: se ve de
       un vistazo que hay mas de un producto. Pedido de Mark. */
    var viz = b.querySelector('.rz-quiz__cinta-viz');
    var fotos = viz.querySelectorAll('img');
    for(i=0;i<fotos.length;i++) viz.removeChild(fotos[i]);
    var chapa = viz.querySelector('.rz-quiz__cinta-n');
    var cuantas = Math.min(enOrden.length, 3);
    for(i=cuantas-1;i>=0;i--){
      var im = document.createElement('img');
      im.alt = ''; im.src = datos(enOrden[i]).img;
      im.style.setProperty('--rz-i', i);
      viz.insertBefore(im, chapa);
    }
    viz.setAttribute('data-n', cuantas);

    var primero = datos(enOrden[0]);
    b.querySelector('.rz-quiz__cinta-n').textContent = c.item_count;
    b.querySelector('.rz-quiz__cinta-txt b').textContent = primero.nombre;
    /* Con un solo producto va su bajada; con varios, cuantos mas hay. */
    var otros = enOrden.length - 1;
    b.querySelector('.rz-quiz__cinta-txt i').textContent =
      otros > 0 ? ('y ' + otros + (otros === 1 ? ' producto más' : ' productos más'))
                : primero.bajada;
    b.querySelector('.rz-quiz__cinta-p').textContent = plata(c.total_price);
    b.classList.add('is-on');
    b.setAttribute('aria-hidden', 'false');
    latir(b);
  }

  /* El latido de la cinta al agregar algo: la chapita del numero pega un salto,
     la foto entra con un golpecito de escala y el total sube desde abajo. Hay que
     sacar la clase, forzar un reflow y volver a ponerla, porque si la clase ya
     esta la animacion no vuelve a arrancar. */
  function latir(b){
    var partes = [b.querySelector('.rz-quiz__cinta-n'),
                  b.querySelector('.rz-quiz__cinta-viz'),
                  b.querySelector('.rz-quiz__cinta-p')];
    for(var i=0;i<partes.length;i++){
      if(!partes[i]) continue;
      partes[i].classList.remove('late');
      void partes[i].offsetWidth;
      partes[i].classList.add('late');
    }
  }

  /* La unica fuente de verdad de la cinta es /cart.js. */
  function mirarCarrito(){
    fetch('/cart.js', { headers:{ 'Accept':'application/json' }, credentials:'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){
        pintarCinta(c);
        /* Y se lo contamos al resto de la pagina. La chapita del header la
           actualiza quien escucha este evento, y el quiz agregaba al carrito por
           su cuenta sin avisar: quedaba la cinta en 3 y el header en 0. */
        document.dispatchEvent(new CustomEvent('rz:carrito', { detail:c }));
      })['catch'](esconderCinta);
  }

  /* ---------- el cambio de pantalla ---------- */
  var MS_SALE   = 560;   /* lo que tarda en irse la pantalla vieja */
  var MS_TANDA2 = 400;   /* cuanto despues del titulo entran las opciones */
  var reloj = null;
  var limpiar = null;

  function pintar(html){
    var h0 = caja.offsetHeight;
    /* La primera vez no hay nada que desvanecer: se escribe y listo. */
    if(!pant.firstChild){ escribir(html, h0); return; }
    if(reloj) clearTimeout(reloj);
    pant.classList.remove('entra');
    /* La SALIDA es toda junta. Hay que borrar el retraso que les puse a las
       opciones al entrar, si no se van 400ms despues que el titulo y se nota. */
    retrasos(0);
    pant.classList.add('se-va');
    reloj = setTimeout(function(){ escribir(html, h0); }, MS_SALE);
  }

  /* Titulo y bajada siempre a cero; el resto, lo que se le pase.
     Con ms = null se BORRA el retraso, y eso hay que hacerlo si o si en cuanto
     termina la entrada. Si queda puesto, el retraso no afecta solo al fundido:
     afecta a TODA transicion posterior de ese elemento. Me lo comi enterito con
     el boton Continuar —quedaba 400ms clavado antes de empezar a ponerse
     negro— y eso es lo que Mark vio como "todo menos fluido". */
  function retrasos(ms){
    var hijos = pant.children;
    for(var i = 0; i < hijos.length; i++){
      var h = hijos[i];
      if(ms === null){ h.style.transitionDelay = ''; continue; }
      var cabeza = h.classList.contains('rz-quiz__h') || h.classList.contains('rz-quiz__sub');
      h.style.transitionDelay = (cabeza ? 0 : ms) + 'ms';
    }
  }

  function escribir(html, h0){
    pant.classList.add('entra');      /* nace invisible */
    pant.classList.remove('se-va');
    pant.innerHTML = html;

    /* La segunda tanda entra despues. El retraso va en linea justamente para no
       pelear con ninguna regla del CSS. */
    retrasos(MS_TANDA2);

    var h1 = pant.offsetHeight;
    if(h0 && h1 && h0 !== h1){
      caja.style.height = h0 + 'px';
      caja.classList.add('esta-animando');
      void caja.offsetHeight;
      caja.style.height = h1 + 'px';
      setTimeout(function(){
        caja.style.height = '';
        caja.classList.remove('esta-animando');
      }, 300);
    }

    /* El ancho de la columna y la cinta se deciden por lo que se acaba de
       dibujar, NO por el numero de paso. Es que al resultado no siempre se llega
       por `ir()`: "No, gracias" y el envio del mail entran por `alResultado()`,
       que pinta directo. Mirando el HTML da igual por donde se haya llegado.
         tarjeta del mail -> columna de 1004
         resultado        -> ancho de pagina
         preguntas        -> la columna angosta de siempre */
    if(inner){
      inner.classList.toggle('es-ancho',  !!pant.querySelector('.rz-quiz__tarjeta'));
      inner.classList.toggle('es-pagina', !!pant.querySelector('.rz-quiz__resbox'));
    }
    /* La pantalla del resultado tiene sus propias reglas: sin los ingredientes de
       fondo (las tarjetas ocupan el ancho de la pagina y se les meten encima) y
       sin barra de progreso, porque el quiz ya termino. Las dos cuelgan de esta
       misma clase. */
    raiz.classList.toggle('es-resultado', !!pant.querySelector('.rz-quiz__resbox'));
    if(pant.querySelector('.rz-quiz__fichas')) mirarCarrito();
    else esconderCinta();

    void pant.offsetHeight;           /* sin esto el navegador no interpola */
    pant.classList.remove('entra');
    /* Y apenas termina la entrada, el retraso se va. */
    if(limpiar) clearTimeout(limpiar);
    limpiar = setTimeout(function(){ retrasos(null); }, MS_TANDA2 + MS_SALE + 80);
    enganchar();
  }

  function progreso(){
    /* Arranca en 1/N y no en cero: con la barra vacia parece que no existe.
       En el de ellos, la primera pantalla ya tiene el primer tramo pintado. */
    var pct = Math.round(((paso + 1) / PASOS.length) * 100);
    barra.style.width = pct + '%';
    /* El Volver se ve SIEMPRE, igual que el de ellos. En la primera pantalla
       saca al que entro del quiz y lo devuelve a donde estaba. */
    volver.hidden = false;
  }

  function ir(n){
    paso = Math.max(0, Math.min(PASOS.length - 1, n));
    var p = PASOS[paso];
    progreso();
    /* La tarjeta del mail es mucho mas ancha que la columna de las preguntas.
       No alcanza con sacarla con margin negativo porque la caja recorta (ya me
       paso con las fichas): la columna entera se ensancha en ese paso. */

    if(p.clave === 'mail')  return pintar(pantallaMail());
    if(p.clave === 'listo') return pintar(pantallaResultado());
    pintar(pantallaPregunta(p));
  }

  function alResultado(){
    pintar(pantallaBuscando());
    paso = PASOS.length - 1;
    progreso();
    /* La espera es a proposito: sin ella el resultado aparece antes de que el
       que responde termine de soltar el boton y no se lee como una respuesta. */
    /* 1500 era el tiempo de la pantalla de "buscando" cuando el cambio era
       instantaneo. Ahora el fundido se come 560 de entrada y 560 de salida, asi
       que la subo para que se siga viendo mas o menos lo mismo. */
    setTimeout(function(){ pintar(pantallaResultado()); }, 2200);
  }

  /* ---------- eventos ---------- */
  function enganchar(){
    var ops = pant.querySelectorAll('[data-op]');
    for(var i=0;i<ops.length;i++){
      ops[i].addEventListener('click', function(){
        var p = PASOS[paso], v = this.getAttribute('data-op');
        if(p.clave === 'meses') v = parseInt(v, 10);
        if(p.multi){
          if(this.getAttribute('data-solo')){ resp.extras = ['nada']; }
          else {
            resp.extras = resp.extras.filter(function(x){ return x !== 'nada'; });
            var k = resp.extras.indexOf(v);
            if(k > -1) resp.extras.splice(k, 1); else resp.extras.push(v);
          }
        } else {
          /* Se puede deseleccionar: volver a tocar la misma opcion la apaga, como
             en el de ellos. Sin esto quedas obligado a dejar una elegida. */
          resp[p.clave] = (resp[p.clave] === v) ? null : v;
        }
        refrescar(p);
      });
    }
    var seguir = pant.querySelector('[data-quiz-seguir]');
    if(seguir) seguir.addEventListener('click', function(){ ir(paso + 1); });

    var saltar = pant.querySelector('[data-quiz-saltar]');
    if(saltar) saltar.addEventListener('click', alResultado);

    var mandar = pant.querySelector('[data-quiz-mail]');
    if(mandar) mandar.addEventListener('click', function(){
      var campo = pant.querySelector('#rz-quiz-mail');
      var err   = pant.querySelector('[data-quiz-error]');
      var val   = (campo.value || '').trim();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)){
        err.hidden = false; campo.focus(); return;
      }
      err.hidden = true;
      /* Se manda al formulario de clientes de Shopify sin recargar. Si falla, el
         quiz sigue igual: el mail no puede ser un obstaculo para ver el resultado. */
      var form = document.getElementById('rz-quiz-form');
      if(form){
        document.getElementById('rz-quiz-mail-real').value = val;
        fetch(form.action, { method:'POST', body:new FormData(form) })['catch'](function(){});
      }
      alResultado();
    });

    var chips = pant.querySelectorAll('[data-quiz-ir]');
    for(var ch=0; ch<chips.length; ch++){
      chips[ch].addEventListener('click', function(){
        var destino = document.getElementById('rz-ficha-' + this.getAttribute('data-quiz-ir'));
        if(destino) destino.scrollIntoView({ behavior:'smooth', block:'start' });
      });
    }

    var rehacer = pant.querySelector('[data-quiz-rehacer]');
    if(rehacer) rehacer.addEventListener('click', function(){
      resp = { vez:null, meses:null, extras:[] }; ir(0);
    });

    /* Cada tarjeta agrega lo suyo. No se abre el cajon del carrito: lo que
       aparece es la barra de abajo, y recien al tocar "Continuar" se va a la
       PAGINA del carrito. Asi lo pidio Mark y asi lo hace Huel. */
    var adds = pant.querySelectorAll('[data-quiz-add]');
    for(var a=0; a<adds.length; a++){
      adds[a].addEventListener('click', function(){
        var b = this;
        if(b.classList.contains('esta-cargando')) return;
        b.classList.add('esta-cargando');
        var dato = {
          id: b.getAttribute('data-id'),
          precio: parseInt(b.getAttribute('data-precio'), 10) || 0,
          nombre: b.getAttribute('data-nombre'),
          bajada: b.getAttribute('data-bajada'),
          img: b.getAttribute('data-img')
        };
        fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ items: [{ id: dato.id, quantity: 1 }] })
        }).then(function(r){
          if(!r.ok) throw new Error('no entro');
          recordar(dato);
          mirarCarrito();          /* de ahi sale el apagado del boton */
          b.classList.remove('esta-cargando');
        })['catch'](function(){
          b.classList.remove('esta-cargando');
          location.href = '/cart';
        });
      });
    }
  }

  /* VOLVER DE LA PAGINA DEL CARRITO. Si tocas Continuar, borras productos alla y
     volves con la flecha del navegador, la pagina se restaura de la cache y el JS
     no se vuelve a ejecutar: la cinta seguia mostrando lo de antes y los botones
     seguian apagados.
     Con esto se vuelve a preguntar el estado del carrito cada vez que la pagina
     se muestra otra vez —vuelta atras o cambio de pestana—, y de ahi sale tanto
     la cinta como el encendido de los botones. */
  function repreguntar(){
    if(pant.querySelector('.rz-quiz__fichas')) mirarCarrito();
  }
  window.addEventListener('pageshow', repreguntar);
  document.addEventListener('visibilitychange', function(){
    if(!document.hidden) repreguntar();
  });

  /* Y ESTE ERA EL CASO QUE FALTABA, que es ademas el mas comun: sacar productos
     desde el cajon del carrito, que se abre SOBRE la misma pagina. Ahi no hay
     vuelta atras ni cambio de pestana, asi que ni pageshow ni visibilitychange
     se enteran: la pagina nunca se fue.
     El cajon ya avisa cada vez que el carrito cambia con el evento rz:carrito y
     manda el carrito nuevo adentro; con eso alcanza y no hace falta volver a
     pedirlo. */
  document.addEventListener('rz:carrito', function(e){
    if(pant.querySelector('.rz-quiz__fichas')) pintarCinta(e.detail);
  });

  volver.addEventListener('click', function(){
    /* Desde la primera pantalla, "Volver" sale del quiz. */
    if(paso === 0){ history.length > 1 ? history.back() : (location.href = '/collections/all'); return; }
    ir(paso - 1);
  });
  ir(0);
})();
